export default "__VITE_ASSET__wOEZzfEN__"